import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmmodal',
  templateUrl: './confirmmodal.component.html',
  styleUrls: ['./confirmmodal.component.scss']
})
export class ConfirmmodalComponent implements OnInit {
  showLoadingButton = false;
  dropDownFormGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) { }

  @Input()
  textContentStyle;

  @Input()
  buttonContentStyle;

  @Input()
  modalDialogHeaderContent;

  @Input()
  modalDropDownFields;

  @Input()
  modalDropDownFieldData;

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  modalButtonVal = this.translateService.instant('APP.AppButton_Submit', {Default: 'SUBMIT'});

  @Input()
  modalLinkButtonVal = '';

  @Input()
  thirdBtnShow: boolean;

  @Input()
  modalButtonForThirdBtn = this.translateService.instant('APP.AppButton_No', {Default: 'No'});

  @Input()
  showCancelButton = false;

  @Input()
  showSubmitButton = '';

  @Input()
  showTitle = true;

  @Input()
  showLinkButton = '';
  @Input()
  lockComponent_Hide=true;
  @Input()
  lockComponentTitleContent= 'LOCKS';
  @Input()
  lockComponentListContent: FormArray = new FormArray([]);

  @Output() linkModalDialogEvent = new EventEmitter<boolean>();

  @Output() cancelModalDialogEvent = new EventEmitter<boolean>();

  @Output() submitModalDialogEvent = new EventEmitter<string>();

  @Output() thirdModalDialogEvent = new EventEmitter<string>();

  @Output() selectionEvent = new EventEmitter<string>();

  ngOnInit(): void {
    this.textContentStyle = this.contentStyle(this.textContentStyle);
    this.buttonContentStyle = this.contentStyle(this.buttonContentStyle);
    this.thirdBtnShow = this.thirdBtnShow ? this.thirdBtnShow : false;
    this.modalDialogHeaderContent = this.modalDialogHeaderContent ? this.modalDialogHeaderContent : 'Confirm';
    this.modalDropDownFields = this.modalDropDownFields ? this.modalDropDownFields : 'N';
    this.modalDropDownFieldData = this.modalDropDownFieldData ? this.modalDropDownFieldData : '';
    this.dropDownFormGroup = this.formBuilder.group({
      dropDownVal: ['', Validators.required]
    });
  }

  contentStyle(style) {
    let styleType = '';
    if (style) {
      if (style === 'center') {
        styleType = 'text-center';
      } else if (this.textContentStyle === 'right') {
        styleType = 'text-right';
      } else if (this.textContentStyle === 'left') {
        styleType = 'text-left';
      }
    }
    return styleType;
  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'cancel') {
      this.cancelModalDialogEvent.emit(true);
    } else if (eventAction === 'submit') {
      this.dropDownFormGroup.markAllAsTouched();
      if (this.modalDropDownFieldData !== '') {
        if (this.dropDownFormGroup.status === 'VALID') {
          this.showLoadingButton = true;
          this.submitModalDialogEvent.emit(this.dropDownFormGroup.value);
          this.selectionEvent.emit(this.dropDownFormGroup.value);
        }
      }
      else {
        this.showLoadingButton = true;
        this.submitModalDialogEvent.emit(this.modalButtonVal);
        this.selectionEvent.emit(this.dropDownFormGroup.value);
      }
    } else if (eventAction === 'No') {
      this.dropDownFormGroup.markAllAsTouched();
      if (this.modalDropDownFieldData !== '') {
        if (this.dropDownFormGroup.status === 'VALID') {
          this.showLoadingButton = true;
          this.thirdModalDialogEvent.emit(this.dropDownFormGroup.value);
          this.selectionEvent.emit(this.dropDownFormGroup.value);
        }
      } else {
        this.showLoadingButton = true;
        this.thirdModalDialogEvent.emit(this.modalButtonForThirdBtn);
        this.selectionEvent.emit(this.dropDownFormGroup.value);
      }
    } else if (eventAction === 'link') {
      this.linkModalDialogEvent.emit(true);
    }
  }

  get dropDownVal() {
      return this.dropDownFormGroup.get('dropDownVal') as FormControl;
    }
  }
